import React, {useEffect, useState} from "react";
import Request from "../../utils/http";
import MUIDataTable from "mui-datatables";
import ButtonSave from "../general/buttonSave";
const request = new Request();


export default function NewUnidadMedida(props){

    const [unidadMedida, setUnidadMedida]=useState({
        name_unidad:''
    })
    //nuestro token para todos
    let token1 = JSON.parse(sessionStorage.getItem("decoAdmin"));
    let token = token1.id;



    let validarUbicacion=data=>{
      let error = 1;
        if (data.name_unidad === null || data.name_unidad.length === 0 || data.name_unidad === "") {
            document.getElementById("name_unidad").classList.add("is-invalid");
            return error;
        }
        return data;
    }
     
    

    const save = async () => {
        let datos=validarUbicacion(unidadMedida);
        if(datos===1){
          alert("favor de llenar los campos");
        }else{
          let data = {
            token: token,
            datos: datos
          }
  
          const response = await request.post("/almacen/saveUnidadMedida", data);
          if (response && !response.error) {
              if (response.result.ok && !response.empty) {
                alert("Unidad Medida Guardado");
                props.recargar();
                //nos permite   vaciar formulario modal
                setUnidadMedida({
                    name_unidad:"",
                });
                document.getElementById("formulario-unidad").reset();
                //fin
              } else {
                console.log(response.result.message);
              }
            } else {
              console.log("error en la peticion");
          }
        }
    }

    return(
        <div className="tab-content">
            <form id="formulario-unidad">
            <div className="row mt-2">
                <div className="col-md-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text">UnidadMedida:</span>
                        </div>
                        <input type="text"  
                            className="form-control text-uppercase" 
                            id="name_unidad" 
                            name="name_unidad" 
                            onChange={e => setUnidadMedida({...unidadMedida,name_unidad:e.target.value.toUpperCase()})} 
                         />
                    </div>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-md-12">
                    <ButtonSave  
                    save={save}
                    closeModal={props.closeModal}
                    />
                </div> 
            </div>
            </form>
        </div>
    );
}